import { Box, Button, IconFont, Input, Popover, usePopoverHeight } from '@byecode/ui'
import type { VariableADTvalue } from '@lighthouse/core'
import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'

import { VariableTree2 } from '../Variable'
import { VariableItem } from '../Variable/VariableSelectDropDown/Item'

const AddIcon = styled.div`
    width: 16px;
    height: 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 0;
    background-color: var(--color-main);
    border-radius: 3px;
`

const Text = styled.span`
    font-size: 12px;
    white-space: nowrap;
    color: var(--color-black);
`
const SCxSearchWrapper = styled.div`
    padding: 4px 12px 0;
    margin-bottom: 8px;
`

interface FieldPickerProps {
    zIndex?: number
    onSelect?: (value: VariableADTvalue) => void
    disabled?: boolean
    fieldOptions?: VariableTree2[]
}

export const FieldPicker: React.FC<FieldPickerProps> = ({ onSelect, disabled, zIndex, fieldOptions }) => {
    const [open, setOpen] = useState(false)
    const { height, ref } = usePopoverHeight({ opened: open })
    const handleSelect = useCallback(
        (value: VariableADTvalue) => {
            setOpen(false)
            onSelect?.(value)
        },
        [onSelect]
    )

    const [searchLabel, setSearchLabel] = useState('')

    const filterData = useMemo(() => {
        const searchVal = searchLabel.trim()
        if (!searchVal) {
            return fieldOptions
        }

        return fieldOptions ? fieldOptions.filter(item => item.label.includes(searchVal)) : []
    }, [fieldOptions, searchLabel])

    const _disabled = disabled || fieldOptions?.length === 0

    return (
        <Box ref={ref}>
            <Popover width={248} withinPortal withinOverlay opened={open} disabled={_disabled} zIndex={zIndex} onChange={setOpen}>
                <Popover.Target>
                    <div onMouseDown={e => e.preventDefault()}>
                        <Button type="text">
                            <AddIcon>
                                <IconFont type="Add" fill="var(--color-white)" />
                            </AddIcon>
                            <Text>插入变量</Text>
                        </Button>
                    </div>
                </Popover.Target>

                <Popover.Dropdown>
                    <Box onMouseDown={e => e.preventDefault()} style={{ maxHeight: height, overflow: 'auto' }}>
                        <SCxSearchWrapper>
                            <Input
                                value={searchLabel}
                                onChange={e => setSearchLabel(e.target.value)}
                                prefix={<IconFont type="Search" />}
                                clearable
                                onClear={() => setSearchLabel('')}
                                placeholder="搜索"
                            />
                        </SCxSearchWrapper>
                        {filterData?.map(item => (
                            <Box key={item.value}>
                                <VariableItem key={item.value} data={item} onChange={handleSelect} path={[item.value]} />
                            </Box>
                        ))}
                    </Box>
                </Popover.Dropdown>
            </Popover>
        </Box>
    )
}
